import React from "react";
import { Stack } from "@mui/material";

import { LabelField, MarkerAnchorFields, NotesField, type MarkerAnchorCopy } from "./MarkerFields";
import MarkerTargetsFields from "./MarkerTargetsFields";
import type { MarkerFieldsProps } from "./MarkerDialog.types";

const ANCHOR_COPY: MarkerAnchorCopy = {
  linkLabel: "Link external event to",
  sessionLabel: "Session",
  dateLabel: "Set the external event date",
};

/**
 * Fields for an external-event marker: the session or date the event is linked
 * to, a label, and optional notes.
 *
 * @param props
 * @param props.values        - Current form values
 * @param props.sessions      - Sessions available to anchor the marker to
 * @param props.onFieldChange - Field setter owned by the dialog shell
 * @param [props.labelInputRef] - Focus target after a "create more" save
 * @param [props.targetsContext] - Enables applying the marker to other targets
 */
const ExternalEventFields: React.FC<MarkerFieldsProps> = ({
  values,
  sessions,
  onFieldChange,
  labelInputRef,
  targetsContext,
}) => (
  <Stack gap={7}>
    <MarkerAnchorFields
      values={values}
      sessions={sessions}
      onFieldChange={onFieldChange}
      copy={ANCHOR_COPY}
    />

    <LabelField
      value={values.label}
      placeholder={'e.g., "New medication started"'}
      inputRef={labelInputRef}
      onChange={(label) => onFieldChange("label", label)}
    />

    <NotesField value={values.notes} onChange={(notes) => onFieldChange("notes", notes)} />

    {targetsContext && (
      <MarkerTargetsFields
        values={values}
        onFieldChange={onFieldChange}
        context={targetsContext}
        markerNoun="event"
      />
    )}
  </Stack>
);

export default ExternalEventFields;
